var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterx = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15S23.284 0 15 0 0 6.716 0 15s6.716 15 15 15",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  width: 13,
  height: 13,
  x: 9,
  y: 9,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 9h12.5v12.5H9z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.418 14.293 20.97 9h-1.08l-3.952 4.596L12.783 9h-3.64l4.772 6.95-4.772 5.55h1.078l4.174-4.853 3.332 4.853h3.641zm-1.477 1.718-.484-.692-3.847-5.507h1.656l3.105 4.445.484.691 4.036 5.777h-1.657z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 9h12.5v12.5H9z"
})))));
export default SvgTwitterx;